function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.813 11.766L9.183 0 6 3.248 17.616 15 6 26.752 9.183 30l11.63-11.766.004.004.791-.808L24 15.01l-.01-.01.01-.01-2.392-2.42-.791-.808-.004.004z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "6",
  y: "0",
  width: "18",
  height: "30"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.813 11.766L9.183 0 6 3.248 17.616 15 6 26.752 9.183 30l11.63-11.766.004.004.791-.808L24 15.01l-.01-.01.01-.01-2.392-2.42-.791-.808-.004.004z",
  fill: "currentColor"
}))));